import { type OauthToken, createOauthToken } from 'models';

import { useMutation } from 'query';
import { loginWithToken } from '../../services';

const defaultMutateOnError = () => {
  // Do nothing
  // This mutation is used within other mutation that handle error already
};

export const useLoginWithTokenMutation = () =>
  useMutation<OauthToken, { token: string; type?: 'magic_token' }>({
    defaultMutateOnError,
    async mutationFn({ token, type }) {
      const oauthResponse = await loginWithToken({
        grant_type: 'password',
        login_token: token,
        login_token_type: type,
      });

      return createOauthToken(oauthResponse.data);
    },
  });
